module.exports = __webpack_public_path__ + "static/media/house.8a0927aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/house.svg
// module id = 2063
// module chunks = 33